import styled from "styled-components";

export const MainSection = styled.section`
  overflow: hidden;
  background-color: #fff;
  .container {
    margin-top: 6rem;
    padding-bottom: 6rem;
  }

  .btn-div {
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      text-transform: none;
    }

    @media (max-width: 991.98px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  color: #032b88;
  margin-top: 4rem;

  @media (max-width: 990px) {
    text-align: center;
    font-size: 2rem;
    margin-top: 0;
  }
`;

export const Text = styled.p`
  font-size: 1.3125rem;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 300;
  line-height: 1.84375rem;
  text-transform: capitalize;
  margin-top: 1rem;
  color: var(--a, #4d4d4d);

  span {
    text-transform: lowercase;
  }

  @media (max-width: 990px) {
    text-align: center;
  }
`;

export const ReadBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #032b88;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.4em 1em;
  border: none;

  margin-top: 1rem;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(90.41deg, #032b88 0.34%, #032b88 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }

  @media (max-width: 990px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
  }
`;

export const ImgWrapper = styled.div`
  text-align: end;

  @media (max-width: 990px) {
    text-align: center;
    margin-top: 4rem;
  }
`;
